var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-creator-guide"},[_c('AppSectionBanners',{attrs:{"no-crop":"","banners":[{
    id: -1,
    media: { path: '/peppernotice1.jpg' }
  }, {
    id: -2,
    media: { path: '/peppernotice2.jpg' }
  }, {
    id: -3,
    media: { path: '/peppernotice3.jpg' }
  }]}}),_c('AppTitleBar',{attrs:{"title":"크리에이터 가이드"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }